(function () {
  'use strict';

  angular
      .module('tfc.Form', []);

})();

(function () {
  'use strict';

  angular
      .module('tfc.Toast',
      [
        'ui.router',
        'ui.bootstrap'
      ]);

})();

(function () {
  'use strict';

  config.$inject = ["$stateProvider", "$httpProvider"];
  angular
      .module('tfc.Nav',
      [
        'ui.router'
      ])
      .config(config);

  // @ngInject
  function config($stateProvider, $httpProvider) {

    // Interceptor to extract the X-Application-Version header
    $httpProvider.interceptors.push('AppVersion');

    $stateProvider
        .state('page', {
          abstract : true,
          template : '<tfc-page full-width=":: false"></tfc-page>'
        })
        .state('widePage', {
          abstract : true,
          template : '<tfc-page full-width=":: true"></tfc-page>'
        })
    ;
  }

})();

(function () {
  'use strict';

  config.$inject = ["$stateProvider", "NavProvider", "$provide"];
  run.$inject = ["$rootScope", "$state", "Auth", "$log", "Toast", "TextUtil"];
  angular
      .module('tfc.sso',
      [
        'tfc.sso.Auth',
        'tfc.sso.tmpls',
        'tfc.Toast',
        'tfc.Nav',
        'tfc.Form'
      ])
      .config(config)
      .run(run);

  // @ngInject
  function config($stateProvider, NavProvider, $provide) {

    NavProvider.addRight({
      state : 'logout',
      // @ngInject
      getText : ["TextUtil", function (TextUtil) {
        return TextUtil.translateOr('auth.logout', function () {
          return 'Log Out';
        });
      }]
    });

    $stateProvider
        .state('login', {
          parent: 'page',
          data : {
            auth : { isPublic : true }
          },
          url : '/login?dest',
          templateUrl : 'sso/Login.tmpl.html',
          controller : 'LoginCtrl as vm'
        })
        .state('logout', {
          url : '/logout',
          template : '',
          resolve : {
            logout : ["$state", "Auth", function ($state, Auth) {
              return Auth.logout().finally(function () {
                $state.go('login');
              });
            }]
          }
        })
        .state('passwordReset', {
          parent : 'page',
          url : '/password/reset',
          templateUrl : 'sso/PasswordReset.tmpl.html',
          controller : 'PasswordResetCtrl as vm'
        })
        .state('passwordResetPublic', {
          parent : 'page',
          url : '/password/resetpub?email',
          data : {
            auth : { isPublic : true }
          },
          templateUrl : 'sso/PasswordResetPublic.tmpl.html',
          controller : 'PasswordResetCtrl as vm'
        })
        .state('forgotPassword', {
          parent : 'page',
          url : '/password/forgot?email&{expired:bool}',
          data : {
            auth : { isPublic : true }
          },
          templateUrl : 'sso/ForgotPassword.tmpl.html',
          controller : 'ForgotPasswordCtrl as vm'
        })
        .state('recoverPassword', {
          parent : 'page',
          // IMPORTANT: This MUST match the url in ForgotPasswordEmail.scala
          url : '/password/recover?t',
          data : {
            auth : { isPublic : true }
          },
          resolve : {
            email : ["$state", "$stateParams", "Auth", function ($state, $stateParams, Auth) {
              return Auth.getEmailByPasswordToken($stateParams.t).then(null, function () {
                $state.go('forgotPassword', { expired : true });
              });
            }]
          },
          templateUrl : 'sso/RecoverPassword.tmpl.html',
          controller : 'RecoverPasswordCtrl as vm'
        })
    ;

    $provide.decorator('$state', ["$delegate", "$injector", function ($delegate, $injector) {
      /**
       * @name $state#can
       * Add this function to the $state service so it can be used in the application.
       *
       * To add access to control to a state, add a data.auth property to the state config:
       * $stateProvider.state('foo', {
       *   data : {
       *     auth : {
       *       // privilege required to view the foo state
       *       privilege : 'somePrivilege',
       *       // redirect to 'some.state' if the user tries to go here w/o the required privilege. defaults to dashboard
       *       defaultTo : 'some.state'
       *     }
       *   },
       *   ...
       * @param stateName String The state to check
       * @returns Boolean If the user can access this state.
       */
      $delegate.can = function (stateName) {
        // Avoid circular dependency
        var Auth = $injector.get('Auth');
        var state = $delegate.get(stateName);
        var privilege = _.get(state, 'data.auth.privilege');
        return !privilege || Auth.can(privilege);
      };

      return $delegate;
    }]);
  }

  // @ngInject
  function run($rootScope, $state, Auth, $log, Toast, TextUtil) {
    // Make sure the current JWT is still valid
    var validatePromise = Auth.validate();

    $rootScope.$on('$stateChangeStart', function (event, toState, toParams) {
      if (!Auth.hasValidated()) {
        event.preventDefault();
        if (!validatePromise) {
          // Re-validate after logging out
          validatePromise = Auth.validate();
        }
        validatePromise.finally(function () {
          // This prevents an infinite loop after logging out
          validatePromise = null;
          $state.go(toState.name, toParams);
        });
      } else {
        var isAuthenticated = Auth.isAuthenticated();

        // If they hit the login page but are already authenticated, just go to the app's default state
        if (isAuthenticated && toState.name === 'login') {
          event.preventDefault();
          $rootScope.$broadcast('auth.login');
        } else if (_.get(toState, 'data.auth.isPublic')) {
          return;
        }

        if (!isAuthenticated) {
          $log.debug('Not authenticated. Redirecting to Login');
          event.preventDefault();
          $state.go('login', { dest : $state.href(toState.name, toParams) });
        } else if (!$state.can(toState.name)) {
          event.preventDefault();
          var defaultTo = _.get(toState, 'data.auth.defaultTo');
          Toast.warn(TextUtil.translateOr('auth.error.lackPrivilege', function () {
            return 'Sorry, you do not have permission to do that.';
          }));
          if (defaultTo) {
            $state.go(defaultTo);
          }
        }
      }
    });
  }

})();

(function () {
  'use strict';

  angular
      .module('tfc.sso.Auth',
      [
        'ui.router',
        'tfc.Toast'
      ]);

})();

(function () {
  'use strict';

  tfcAutofocus.$inject = ["$timeout"];
  angular
      .module('tfc.Form')
      .directive('tfcAutofocus', tfcAutofocus);

  // @ngInject
  function tfcAutofocus($timeout) {
    return {
      restrict : 'A',
      link : function ($scope, $el, $attrs) {
        var autoFocus = $attrs.tfcAutofocus || 'true';
        $timeout(function () {
          if ($scope.$eval(autoFocus)) {
            $el[0].focus();
          }
        });
      }
    };
  }

})();

(function () {
  'use strict';

  angular
      .module('tfc.Form')
      .directive('tfcConfirmInput', tfcConfirmInput);

  // @ngInject
  function tfcConfirmInput() {
    return {
      restrict : 'A',
      require : ['ngModel', '^form'],
      link : function ($scope, $el, $attrs, ctrls) {
        var ngModel = ctrls[0],
            form = ctrls[1];
        var name = $attrs.tfcConfirmInput,
            otherNgModel = form[name];

        if (!otherNgModel) {
          throw new Error('Cannot find field:' + name);
        }

        $scope.$watch(
            function () {
              return ngModel.$dirty && otherNgModel.$isEmpty(otherNgModel.$modelValue);
            },
            function (hasBeenCleared) {
              if (hasBeenCleared) {
                // reset this field when the other field is cleared
                ngModel.$setViewValue('');
                ngModel.$setPristine();
                ngModel.$render();
              }
            }
        );

        $scope.$watch(
            function () {
              // don't validate until this field has been touched
              return ngModel.$pristine
                  || form[name].$modelValue === ngModel.$modelValue;
            },
            function (valid) {
              ngModel.$setValidity('confirm', valid);
            }
        );
      }
    };
  }

})();

(function () {
  'use strict';

  ToastCtrl.$inject = ["$scope", "Toast"];
  angular
      .module('tfc.Toast')
      .controller('ToastCtrl', ToastCtrl)
      .directive('tfcToast', tfcToast);

  // @ngInject
  function ToastCtrl($scope, Toast) {
    var vm = this;
    $scope.$watchCollection(Toast.list, function (messages) {
      vm.messages = messages;
    });
    vm.dismiss = Toast.dismiss;
    vm.translate = Toast.translate;
  }

  // @ngInject
  function tfcToast() {
    return {
      controller : 'ToastCtrl as vm',
      scope : {},
      templateUrl : 'Toast/Toast.tmpl.html'
    };
  }

})();

(function () {
  'use strict';

  angular
      .module('tfc.Toast')
      .provider('Toast', ToastProvider);

  // @ngInject
  function ToastProvider() {
    // true is a special value that means to use 'translateFilter' if it exists
    var translator = true;
    // Whether the developer has called ToastProvider.useTranslate.
    // If it's called more than once, it's probably a bug.
    var calledUseTranslate = false;
    var typeDefaults = {
      success : {
        delay : 2000
      },
      info : {
        delay : 5000
      },
      warn : {
        delay : 10000
      },
      error : {
        delay : false // never hide automatically
      }
    };

    function checkType(type) {
      if (!typeDefaults.hasOwnProperty(type)) {
        throw new Error('Invalid toast level [' + type + ']');
      }
    }

    function checkDelay(delay) {
      if (typeof delay !== 'Boolean' && isNaN(delay)) {
        throw new Error('Invalid delay [' + delay + ']');
      }
    }

    /**
     * Sets how or whether to translate toast message texts and titles.
     * @param use How or whether to use a translator. Defaults to using 'translateFilter' if it exists. Can be:
     *            false - Don't use any translation mechanism. Will just return the text or title as is.
     *            String - The name of a service whose value is a function taking text and data.
     *            Function - A custom translation function taking text and data.
     */
    this.useTranslate = function (use) {
      if (calledUseTranslate) {
        console.warn('ToastProvider.useTranslate has already been called with [' + translator + '].',
            'This is probably a bug.');
      }
      calledUseTranslate = true;
      if (use === false || _.isFunction(use) || _.isString(use)) {
        translator = use;
      } else {
        throw new Error('Illegal useTranslate value');
      }
    };

    this.getDefaultDelay = function (type) {
      checkType(type);
      return typeDefaults[type].delay;
    };

    this.setDefaultDelay = function (type, delay) {
      checkType(type);
      checkDelay(delay);
      typeDefaults[type].delay = delay;
      return this;
    };

    this.$get = ["$rootScope", "$injector", "$timeout", "$state", "$log", function ($rootScope, $injector, $timeout, $state, $log) {
      var messages = [];

      $rootScope.$on('$stateChangeSuccess', dismissIrrelevant);

      if (translator === true) {
        // auto-detect translateFilter, or turn it off
        if ($injector.has('translateFilter')) {
          translator = $injector.get('translateFilter');
        } else {
          $log.debug('translateFilter not present -- turning off Toast translations');
          translator = false;
        }
      }

      return {
        // Called when the user clicks the X button
        dismiss : dismiss,
        translate : translate,
        list : function () { return messages.slice(); },
        success : withAlertType('success', typeDefaults.success),
        info : withAlertType('info', typeDefaults.info),
        warn : withAlertType('warning', typeDefaults.warn),
        error : withAlertType('danger', typeDefaults.error)
      };

      function translate(text, data) {
        var fn;
        if (!translator) {
          return text;
        }
        if (_.isFunction(translator)) {
          fn = translator;
        } else if (_.isString(translator)) {
          if (!$injector.has(translator)) {
            throw new Error('Toast set to use [' + translator + '] for translation, but it does not exist. ' +
                "If you aren't using translations, you need to call ToastProvider.useTranslate(false).");
          }
          fn = $injector.get(translator);
          if (!_.isFunction(fn)) {
            throw new Error('Toast useTranslate service [' + translator + '] is not a function');
          }
        } else {
          // This should never happen unless we add a feature and forget to implement it here
          throw new Error('Unsupported useTranslate value [' + translator + ']');
        }
        return fn(text, data);
      }

      function withAlertType(alertType, defaults) {
        return function (title, text, config) {
          if (arguments.length === 1) {
            text = title;
            title = null;
            config = null;
          } else if (!_.isString(text)) {
            config = text;
            text = title;
            title = null;
          }

          config = _.defaults({}, config, defaults, {
            state : false
          });

          if (config.state === true) {
            config.state = $state.current.name;
          }

          checkDelay(config.delay);

          return postMessage(_.extend(config, {
            alertType : alertType,
            title : title,
            text : text,
            dismissed : false,
            quickFade : false
          }));
        };
      }

      function deleteMessage(message) {
        $timeout.cancel(message.$timeout);
        _.pull(messages, message);
      }

      function postMessage(message) {
        messages.push(message);

        if (message.delay !== false) {
          message.$timeout = $timeout(function () {
            deleteMessage(message);
          }, message.delay);
        }
        var dismissMessage = function () {
          deleteMessage(message);
        };
        return dismissMessage
      }

      function dismiss(message) {
        // quickFade makes it fade out quickly when the user dismisses the toast
        // TODO: There's probably a better way
        message.quickFade = true;
        // TODO: This is done asynchronously in the original -- make sure that's unnecessary
        $timeout(function () {
          deleteMessage(message);
        });
      }

      function dismissIrrelevant() {
        // slice because `dismiss` will mutate `messages`
        _.each(messages.slice(), function (message) {
          // dismiss every state-bound message whose state we've left
          if (message.state && !isInState(message.state)) {
            dismiss(message);
          }
        });
      }

      // returns whether we're in the given state or one of its children
      function isInState(stateName) {
        var state = $state.$current;
        do {
          if (state.self.name === stateName) {
            return true;
          }
          state = state.parent;
        } while (state);
        return false;
      }
    }];
  }

})();

(function () {
  'use strict';

  AppVersion.$inject = ["$q"];
  tfcAppVersion.$inject = ["AppVersion"];
  angular
      .module('tfc.Nav')
      .factory('AppVersion', AppVersion)
      .directive('tfcAppVersion', tfcAppVersion);

  // @ngInject
  function AppVersion($q) {

    var appVersion = '';
    var appCopyright = '';

    function extractMetadata(response) {
      var version = response.headers('X-Application-Version');
      if (version) {
        appVersion = version;
      }
      var copyright = response.headers('X-Application-Copyright');
      if (copyright) {
        appCopyright = copyright;
      }
    }

    return {
      getAppVersion : function () { return appVersion; },
      getAppCopyright : function () { return appCopyright; },
      // response interceptor
      response : function (response) {
        extractMetadata(response);
        return response;
      },
      responseError : function (response) {
        extractMetadata(response);
        return $q.reject(response);
      }
    };
  }

  // @ngInject
  function tfcAppVersion(AppVersion) {
    return {
      scope : {},
      templateUrl : 'Nav/AppVersion.tmpl.html',
      link : function ($scope) {
        $scope.getAppVersion = AppVersion.getAppVersion;
        $scope.getAppCopyright = AppVersion.getAppCopyright;
      }
    };
  }

})();

(function () {
  'use strict';

  tfcCompileHtml.$inject = ["$compile"];
  angular
      .module('tfc.Nav')
      .directive('tfcCompileHtml', tfcCompileHtml);

  // @ngInject
  function tfcCompileHtml($compile) {
    return {
      restrict : 'A',
      link : function ($scope, $el, $attrs) {
        var childScope;
        $scope.$watch($attrs.tfcCompileHtml, function (html) {
          if (childScope) {
            childScope.destroy();
          }
          $el.contents().remove();
          $el.html(html);
          childScope = $scope.$new();
          $compile($el.contents())(childScope);
        });
      }
    };
  }
  
})();
(function () {
  'use strict';

  MainNavCtrl.$inject = ["$injector", "$scope", "$element", "$document", "Nav", "Auth"];
  angular
      .module('tfc.Nav')
      .controller('MainNavCtrl', MainNavCtrl)
      .directive('tfcMainNav', tfcMainNav);

  // @ngInject
  function MainNavCtrl($injector, $scope, $element, $document, Nav, Auth) {
    var vm = this,
        isExpanded = false,
        mainItems,
        rightItems,
        userItems;

    function inject(fnName) {
      return function (item) {
        return $injector.invoke(item[fnName]);
      };
    }

    vm.getText = inject('getText');
    vm.onClick = inject('onClick');
    vm.canAccess = inject('canAccess');

    vm.isActive = function (item) {
      return _.some([item].concat(item.children || []), inject('isActive'));
    };

    vm.isExpanded = function () {
      return isExpanded;
    };

    vm.toggle = function () {
      isExpanded = !isExpanded;
    };

    vm.appTitle = function () {
      return vm.getText(Nav.appTitle());
    };

    vm.appWelcome = function () {
      return vm.getText(Nav.appWelcome());
    };

    vm.mainItems = function () {
      return vm.user ? mainItems : [];
    };

    vm.rightItems = function () {
      return vm.user ? rightItems : [];
    };

    vm.userItems = function () {
      return vm.user ? userItems : [];
    };

    $scope.$on('$stateChangeSuccess', function () {
      isExpanded = false;
    });

    $document.on('click', function (e) {
      if (!$element[0].contains(e.target)) {
        isExpanded = false;
        $scope.$apply();
      }
    });

    $scope.$watch(Nav.mainMenu, function (items) {
      mainItems = items;
    });
    $scope.$watch(Nav.rightMenu, function (items) {
      rightItems = items;
    });
    $scope.$watch(Nav.userMenu, function (items) {
      userItems = items;
    });
    // we don't want to watch getUser because it returns a new one each time,
    // so we'd have to
    $scope.$watch(Auth.isAuthenticated, function () {
      vm.user = Auth.getUser();
    });

    $scope.$watch(vm.appTitle, function (title) {
      if (title) {
        document.title = title + ' | True Fit';
      }
    });
  }

  // @ngInject
  function tfcMainNav() {
    return {
      restrict : 'E',
      controller : 'MainNavCtrl as vm',
      bindToController : true,
      templateUrl : 'Nav/MainNav.tmpl.html',
      scope : {
        fullWidth : '='
      }
    };
  }

})();

(function () {
  'use strict';

  angular
      .module('tfc.Nav')
      .provider('Nav', NavProvider);

  // @ngInject
  function NavProvider() {

    var title = { text : '' };
    var welcome = {
      // @ngInject
      getText : ["TextUtil", "Auth", function (TextUtil, Auth) {
        return TextUtil.translateOr('app.welcome', Auth.getUser(), function (user) {
          return 'Welcome, ' + user.firstName;
        });
      }]
    };

    var mainMenuItems = [],
        rightMenuItems = [],
        userMenuItems = [
          {
            text : 'Change Password',
            state : 'passwordReset'
          }
        ];

    /**
     * @name NavProvider#addMain
     * Add a nav button that will be left-justified in the navbar.
     *
     * The 'Injectable' type is something that `$injector` understands:
     * @see https://code.angularjs.org/1.4.10/docs/api/auto/service/$injector#annotate
     * Note: The 'Argument names' syntax from the above link is not allowed.
     *
     * The configuration's main methods are:
     * - getText {Injectable} Returns the nav button's text
     * - onClick {Injectable} Function called when the user clicks the nav button
     * - isActive {Injectable} Returns whether the nav button should be highlighted as 'active'
     *
     * The configuration also supports a few short-hand properties, which obviate the need to define
     * the main methods listed above. These short-hand properties are:
     * - text {String} For when the nav button has static text. `getText` is ignored if this is set.
     * - translate {String|Object} For use with angular-translate. This is ignored if `text` is set.
     *        `getText` is ignored if this is set. Setting to a string is the same as { key: `translate` }.
     *        This defines what's passed to the translate filter. If `translate` is an object, it can have:
     *        - key {String|Injectable} Defines the translation key.
     *        - values {Object|Injectable} Defines the translation params.
     *        @see https://angular-translate.github.io/docs/#/api/pascalprecht.translate.filter:translate
     * - state {String|Object} Defines the ui-router state to navigate to onClick.
     *        `onClick` is ignored if this is set. Setting to a string is the same as { name: `state` }.
     *        This defines what's passed to `$state.go`. This will create default `onClick` and `isActive` options,
     *        which you can still overwrite. If `state` is an object, it can have:
     *        - name {String|Injectable} Defines the state to go to.
     *        - params {Object|Injectable} Defines the state params.
     *        - options {Object|Injectable} Defines the `$state.go` options.
     *        @see http://angular-ui.github.io/ui-router/site/#/api/ui.router.state.$state#methods_go
     *
     * @param config {Object} The item's configuration. See above for details
     * @returns {NavProvider} Returns `this`, so as to be chainable
     */
    this.addMain = function (config) {
      require(_.isPlainObject(config), 'You must supply a config object to NavProvider#addMain');
      mainMenuItems.push(config);
      return this;
    };

    /**
     * @name NavProvider#addRight
     * Add a nav button that will be right-justified in the navbar. This has an identical API to NavProvider#addMain
     * @param config {Object} The item's configuration.
     * @returns {NavProvider} Returns `this`, so as to be chainable
     * @see NavProvider#addMain
     */
    this.addRight = function (config) {
      require(_.isPlainObject(config), 'You must supply a config object to NavProvider#addRight');
      rightMenuItems.push(config);
      return this;
    };

    this.addUser = function (config) {
      require(_.isPlainObject(config), 'You must supply a config object to NavProvider#addRight');
      userMenuItems.push(config);
      return this;
    };

    this.setWelcome = function (config) {
      welcome = config;
      return this;
    };

    this.setAppTitle = function (config) {
      title = config;
      return this;
    };

    this.removeChangePassword = function() {
      _.remove(userMenuItems, {state: 'passwordReset'});
      return this;
    };

    this.$get = ["$injector", "$sce", function ($injector, $sce) {
      var invoke = $injector.invoke;
      /**
       * Returns whether something is injectable.
       * @see https://code.angularjs.org/1.4.10/docs/api/auto/service/$injector#annotate
       * Note: The 'Argument names' syntax from the above link is not allowed.
       */
      function isInjectable(value) {
        try {
          $injector.annotate(value, /*strictDi=*/true);
          return true;
        } catch (e) {
          return false;
        }
      }

      /**
       * Returns a value that can be passed to $injector.invoke. This means
       * if `value` is injectable, `value` is returned. Otherwise, this returns
       * an injectable function that will return `value`.
       */
      function toInjectable(value) {
        return isInjectable(value) ? value : function () {
          return value;
        };
      }

      function configureState(config) {
        if (config.state) {
          // support simple `state: 'foo'` syntax
          if (_.isString(config.state)) {
            config.state = {
              name : config.state
            };
          }
          // if the values aren't injectable functions, wrap them in one
          config.state.name = toInjectable(config.state.name);
          config.state.params = toInjectable(config.state.params);
          config.state.options = toInjectable(config.state.options);
          // _.defaults to allow overriding
          _.defaults(config, {
            // @ngInject
            onClick : ["$state", function ($state) {
              $state.go(
                  invoke(config.state.name),
                  invoke(config.state.params),
                  invoke(config.state.options)
              );
            }],
            // @ngInject
            isActive : ["$state", function ($state) {
              return $state.includes(invoke(config.state.name));
            }],
            // Whether the user can access this item
            // @ngInject
            canAccess : ["$state", function ($state) {
              return $state.can(invoke(config.state.name));
            }]
          });
        } else if (!config.onClick && !config.isActive) {
          if (!_.get(config, 'children.length')) {
            console.warn('Nav item configured with no "state" property and no children. ' +
                'Did you forget to add a "state" to this nav item?', config);
          } else {
            // With no state defined, make the parent act as the first child the user has access to
            var fromFirstChild = function(keyPath) {
              return function () {
                var firstAccessibleChild = _.find(config.children, function (child) {
                  return invoke(child.canAccess);
                });
                var fn = _.get(firstAccessibleChild, keyPath);
                return fn && invoke(fn);
              };
            };
            config.state = {
              name : fromFirstChild('state.name'),
              params : fromFirstChild('state.params'),
              options : fromFirstChild('state.options')
            };
            config.onClick = fromFirstChild('onClick');
            config.isActive = fromFirstChild('isActive');
            config.canAccess = fromFirstChild('canAccess');
          }
        }
      }

      function configureText(config) {
        if (_.isString(config.text)) {
          config.getText = function () {
            return config.text;
          };
        } else if (config.translate) {
          // support simple `translate: 'app.welcome'` syntax
          if (_.isString(config.translate)) {
            config.translate = {
              key : config.translate
            };
          }
          config.translate.key = toInjectable(config.translate.key);
          config.translate.values = toInjectable(config.translate.values);
          // @ngInject
          config.getText = function () {
            var translateFilter;
            if (!$injector.has('translateFilter')) {
              throw new Error('Nav: menu item set "translate" property without angular-translate present');
            }
            translateFilter = $injector.get('translateFilter');
            return translateFilter(
                invoke(config.translate.key),
                invoke(config.translate.values)
            );
          };
        }
      }

      function configureTemplate(config) {
        if (!_.isString(config.template)) {
          return;
        }
        config.template = $sce.trustAsHtml(config.template);
      }

      configureText(title);
      configureText(welcome);

      // massage config items so they're usable
      mainMenuItems
          .concat(rightMenuItems)
          .concat(userMenuItems)
          .forEach(function (config) {
            configureState(config);
            configureText(config);
            // TODO: implement the UI for child nav items
            config.children = _.map(config.children, function (child) {
              configureState(child);
              configureText(child);
              // only children get the ability to template for now
              configureTemplate(child);
              return child;
            });
          });

      return {
        appTitle : appTitle,
        appWelcome : appWelcome,
        mainMenu : mainMenu,
        rightMenu : rightMenu,
        userMenu : userMenu
      };

      function appTitle() {
        return title;
      }

      function appWelcome() {
        return welcome;
      }

      function mainMenu() {
        return mainMenuItems
      }

      function rightMenu() {
        return rightMenuItems;
      }

      function userMenu() {
        return userMenuItems;
      }
    }];
  }

  function require(x, msg) {
    if (!x) {
      throw new Error(msg);
    }
  }

})();

(function () {
  'use strict';

  angular
      .module('tfc.Nav')
      .directive('tfcPage', tfcPage);

  // @ngInject
  function tfcPage() {
    return {
      templateUrl : 'Nav/Page.tmpl.html',
      scope : {
        fullWidth : '='
      }
    };
  }

})();

(function () {
  'use strict';

  TextUtil.$inject = ["$injector"];
  angular
      .module('tfc.Nav')
      .factory('TextUtil', TextUtil);

  // @ngInject
  function TextUtil($injector) {

    var translateFilter;
    if ($injector.has('translateFilter')) {
      translateFilter = $injector.get('translateFilter');
    }

    return {
      translateOr : translateOr
    };

    /**
     * @name TextUtil#translateOr
     *
     * Uses angular-translate to translate the `translationId` or calls the `fallbackFn`
     * with `values`.
     *
     * @param translationId
     * @param [values]
     * @param fallbackFn
     * @returns String The result of the translation, or the return value of `fallbackFn`
     *                 if angular-translate is not present
     */
    function translateOr(translationId, values, fallbackFn) {
      if (arguments.length < 2) {
        throw new Error('translateOr requires at least a translationId and fallback function,' +
            'with optional values in between.');
      }
      if (arguments.length === 2) {
        fallbackFn = values;
        values = undefined;
      }
      if (translateFilter) {
        return translateFilter(translationId, values);
      } else {
        return fallbackFn(values);
      }
    }
  }

})();

(function () {
  'use strict';

  ForgotPasswordCtrl.$inject = ["$stateParams", "Auth"];
  angular
      .module('tfc.sso')
      .controller('ForgotPasswordCtrl', ForgotPasswordCtrl);

  // @ngInject
  function ForgotPasswordCtrl($stateParams, Auth) {
    var vm = this;

    vm.sent = false;
    vm.expired = $stateParams.expired;
    vm.email = $stateParams.email;

    vm.submit = function () {
      Auth.forgotPassword(vm.email).then(function () {
        vm.sent = true;
      });
    };
  }

})();

(function () {
  'use strict';

  LoginCtrl.$inject = ["Auth"];
  angular
      .module('tfc.sso')
      .controller('LoginCtrl', LoginCtrl);

  // @ngInject
  function LoginCtrl(Auth) {
    var vm = this;
    vm.usingActiveDirectory = Auth.usingActiveDirectory;

    vm.user = {};

    vm.login = function () {
      Auth.login(vm.user);
    };
  }

})();

(function () {
  'use strict';

  PasswordResetCtrl.$inject = ["$state", "Auth", "Toast"];
  angular
      .module('tfc.sso')
      .controller('PasswordResetCtrl', PasswordResetCtrl);

  // @ngInject
  function PasswordResetCtrl($state, Auth, Toast) {
    var vm = this;

    var user = Auth.getUser();

    vm.isAuthenticated = function () {
      return !!user;
    };

    vm.user = {
      user : $state.params.email || (user && user.email)
    };

    vm.error = null;

    vm.save = function () {
      vm.error = null;
      Auth.resetPassword(vm.user).then(function () {
        Toast.success('Password successfully changed');
        $state.go('login');
      });
    };
  }

})();

(function () {
  'use strict';

  PasswordResetFormCtrl.$inject = ["Auth"];
  angular
      .module('tfc.sso')
      .controller('PasswordResetFormCtrl', PasswordResetFormCtrl)
      .directive('tfcPasswordResetForm', tfcPasswordResetForm);

  // @ngInject
  function PasswordResetFormCtrl(Auth) {
    var vm = this;

    vm.isAuthenticated = function () {
      return !!Auth.getUser();
    };
  }

  // @ngInject
  function tfcPasswordResetForm() {
    return {
      bindToController : true,
      controller : 'PasswordResetFormCtrl as vm',
      templateUrl : 'sso/PasswordResetForm.tmpl.html',
      scope : {
        user : '=',
        onSubmit : '&'
      }
    };
  }

})();

(function () {
  'use strict';

  RecoverPasswordCtrl.$inject = ["$state", "$stateParams", "email", "Auth", "Toast", "TextUtil"];
  angular
      .module('tfc.sso')
      .controller('RecoverPasswordCtrl', RecoverPasswordCtrl);

  // @ngInject
  function RecoverPasswordCtrl($state, $stateParams, email, Auth, Toast, TextUtil) {
    var vm = this;

    vm.email = email;

    vm.submit = function () {
      Auth.recoverPassword($stateParams.t, vm.user.newPass).then(function () {
        Toast.success(TextUtil.translateOr('auth.password.reset.success', function () {
          return 'Your password has been reset.';
        }));
        $state.go('login');
      });
    };
  }

})();

(function () {
  'use strict';

  // tfc.sso's run block calls Auth.validate() (see sso.module.js).
  // This is a separate module so tfc.sso's run doesn't have to be mocked for every test
  config.$inject = ["$httpProvider", "AuthProvider"];
  angular
      .module('tfc.sso.Auth')
      .provider('Auth', Auth)
      .config(config);

  // @ngInject
  function config($httpProvider, AuthProvider) {


  }

  // @ngInject
  function Auth() {
    var basePath = 'ui';
    var paths = {
      login : '/auth/login',
      logout : '/auth/logout',
      validate : '/auth/validate',
      resetPassword: '/auth/password/reset',
      forgotPassword: '/auth/password/forgot',
      recoverPassword: '/auth/password/recover',
      getEmailByPasswordToken : '/auth/password/token'
    };

    var _usingActiveDirectory = false;

    this.setBasePath = function (bp) {
      basePath = bp;
    };

    this.setPath = function (name, path) {
      paths[name] = path;
    };

    this.usingActiveDirectory = function () {
      _usingActiveDirectory = true
    };

    this.$get = ["$rootScope", "$http", "$log", "$q", "$state", "$urlRouter", "CookieJar", "Toast", function ($rootScope, $http, $log, $q, $state, $urlRouter, CookieJar, Toast) {
      var _authenticatedUser;
      var _isValid,
          _hasValidated;

      function initVars() {
        _authenticatedUser = null;
        _isValid = false;
        _hasValidated = false;
      }

      initVars();

      return {
        getUser : getUser,
        login : login,
        logout : logout,
        validate : validate,
        resetPassword : resetPassword,
        forgotPassword : forgotPassword,
        recoverPassword : recoverPassword,
        getEmailByPasswordToken : getEmailByPasswordToken,
        isAuthenticated : isAuthenticated,
        hasValidated : function () { return _hasValidated; },
        can : can,
        usingActiveDirectory : function () { return _usingActiveDirectory}
      };

      function getUser() {
        if (isAuthenticated()) {
          return _authenticatedUser;
        } else {
          return null;
        }
      }

      function login(credentials) {
        return $http.post(basePath + paths.login, credentials).then(function (response) {
          _authenticatedUser = response.data;
          _isValid = true;
          var expiration = getUser().passwordExpiration;
          var ttlMs = expiration - Date.now();
          var ttlDays = Math.floor(ttlMs / 1000 / 60 / 60 / 24);
          var when;
          // Give them 7 days of warning before it expires
          if (ttlDays <= 7) {
            when = new Date(expiration).toLocaleDateString(); // 'mm/dd/yyyy'
            Toast.warn('Your password will expire on ' + when + '. Please reset it');
          }
          if ($state.params.dest) {
            document.location.hash = $state.params.dest;
            $urlRouter.sync();
          } else {
            $rootScope.$broadcast('auth.login');
          }
        }, handleError);
      }

      function logout() {
        return $http.post(basePath + paths.logout).then(function () {
          initVars();
          $rootScope.$broadcast('auth.logout');
        });
      }

      function validate() {
        return $http.get(basePath + paths.validate).then(function (response) {
          _authenticatedUser = response.data;
          _isValid = true;
        }, function(response) {
          _isValid = false;
          if (response.status === 403) {
            // They're already logged in from somewhere else, but they can't access this app.
            Toast.error('You do not have permission to use this application');
          } else if (response.status === 401) {
            _authenticatedUser = null;
          } else if (response.status >= 500) {
            Toast.error('Something is wrong with the server. Please contact operations.');
          } else {
            Toast.error('Unexpected error. (code = ' + response.status + ')');
          }
        }).finally(function () {
          _hasValidated = true;
        });
      }

      function resetPassword(change) {
        change = _.pick(change, ['user', 'pass', 'newPass']);
        return $http.post(basePath + paths.resetPassword, change)
            .then(null, handleError);
      }

      function forgotPassword(email) {
        return $http.post(basePath + paths.forgotPassword, { email : email });
      }

      function recoverPassword(token, newPassword) {
        return $http.post(basePath + paths.recoverPassword, {
          token : token,
          newPassword : newPassword
        }).then(null, handleError);
      }

      function getEmailByPasswordToken(token) {
        return $http.get(basePath + paths.getEmailByPasswordToken, {
          params : { token : token }
        }).then(_.property('data'));
      }

      function handleError(response) {
        if (response.status === 400) {
          switch (_.get(response.data, '_type')) {
            case 'PasswordInsecure':
              Toast.error(response.data.message, { state : true });
              break;
            case 'PasswordUnchanged':
              Toast.error('You cannot use your current or ' +
                  response.data.recentPasswordCount + ' most recent passwords.', { state : true });
              break;
            default:
              Toast.error('Oops! Something went wrong.');
              break;
          }
        } else if (response.status === 401) {
          switch (_.get(response.data, '_type')) {
            case 'TooManyFailedLoginAttempts':
              Toast.error("You've failed to login too many times. Please try again later.");
              break;
            case 'MustResetPassword':
              var user = response.data.user;
              if (user.passwordExpiration < Date.now()) {
                Toast.warn('Your password has expired. Please change it.');
              }
              $state.go('passwordResetPublic', { email : user.email });
              break;
            default:
              Toast.warn('Invalid email or password', { state : true });
          }
        } else if (response.status >= 500) {
          // TODO: move to an interceptor
          Toast.error('Unexpected error', { state : true });
        }
        return $q.reject(response);
      }

      function isAuthenticated() {
        return _isValid && !!_authenticatedUser;
      }

      function can(permission) {
        var user = getUser();
        return !!user && -1 !== user.privileges.indexOf(permission);
      }
    }];
  }

})();

(function () {
  'use strict';

  CookieJar.$inject = ["$log"];
  angular
      .module('tfc.sso.Auth')
      .factory('CookieJar', CookieJar);

  // @ngInject
  function CookieJar($log) {

    return {
      /**
       * @name CookieJar#get
       * @param name {string} The name of the cookie
       * @returns {string} The value of the cookie, or undefined if it does not exist.
       */
      get : get,
      /**
       * @name CookieJar#set
       * @param {object} data The cookie configuration, which has the following fields:
       *      - {string} name The name of the cookie.
       *      - {string} value The value of the cookie.
       *      - {string} [domain] The domain for the cookie. Setting to true will use the current domain's parent domain.
       *                          Omitting the domain sets a session cookie.
       *      - {string} [path] The path to which this cookie applies. Defaults to '/'.
       *      - {number} [maxAge] Integer representing # seconds for the cookie to last. Anything <= 0 will delete the cookie.
       */
      set : set,
      /**
       * @name CookieJar#remove
       * @param {object|string} data The name of the cookie, or an object containing:
       *      - {string} name The name of the cookie.
       *      - {string} [domain] The domain of the cookie. Defaults to the current domain's parent domain.
       *      - {string} [path] The path of the cookie to delete. Defaults to '/'.
       */
      remove : remove
    };

    function isNonEmptyString(x) {
      return _.isString(x) && x.length > 0;
    }

    function defaultDomain() {
      var domain = location.hostname;
      if (domain === 'localhost') {
        $log.warn("Cookies don't really work on localhost. Using a session cookie");
        return;
      }
      var parts = domain.split('.');
      if (parts.length > 2) {
        return parts.slice(1).join('.');
      } else {
        return domain;
      }
    }

    function get(name) {
      var cookiePairs = document.cookie.split('; ');
      var value;
      _.each(cookiePairs, function (pair) {
        var split = pair.split('=');
        if (split[0] === name) {
          value = split[1];
          return false;
        }
      });
      return value;
    }

    function set(data) {
      var cookie, expires;
      if (_.isPlainObject(data) && _.isString(data.name) && _.isString(data.value)) {

        cookie = data.name + '=' + data.value;

        if (data.domain === true) {
          data.domain = defaultDomain();
        }

        if (isNonEmptyString(data.domain)) {
          cookie += ';domain=' + data.domain;
        }

        data.path = isNonEmptyString(data.path) ? data.path : '/';
        cookie += ';path=' + data.path;

        if (!isNaN(data.maxAge)) {
          if (data.maxAge <= 0) {
            data.maxAge = expires = 0;
          } else {
            expires = new Date().getTime() + data.maxAge * 1000;
          }
          cookie += ';max-age=' + data.maxAge;
          cookie += ';expires=' + new Date(expires).toUTCString();
        }

        document.cookie = cookie;
      }
    }

    function _remove(data) {
      set({
        name: data.name,
        value: '',
        domain: data.domain,
        path: data.path,
        maxAge: 0
      });
    }

    function remove(data) {
      if (_.isString(data)) {
        data = {
          name : data,
          domain : true
        };
      }

      _remove(data);

      if (get(data.name) != null && data.domain) {
        $log.debug('Cookie [' + data.name + '] still present after remove. ' +
            'Trying again as a session cookie');
        delete data.domain;
        _remove(data);
      }
    }
  }

})();
